import React, { ReactNode } from "react";

type StepsTabsType = {
  currStep: number;
  setCurrStep: React.Dispatch<React.SetStateAction<number>>;
  steps: {
    index: number;
    title: string;
    icon: ReactNode;
  }[];
};

const StepsTabs = ({ currStep, steps, setCurrStep }: StepsTabsType) => {
  return (
    <div className="stepsContainer">
      {steps.map((step) => (
        <button
          type="button"
          className={`step ${step.index === currStep ? "active" : ""}`}
          key={step.index}
          onClick={() => setCurrStep(step.index)}
        >
          {step.icon}
          <p className="text">{step.title}</p>
        </button>
      ))}
    </div>
  );
};

export default StepsTabs;
